export default __webpack_public_path__ + "static/media/create-on.1a42521a.svg";